import Campana from "./CargadeCodigos";

export default Campana;
